const currentYear = (new Date()).getFullYear();
const currentPeriod = `${currentYear}-${currentYear + 1}`;
const lastYear = 1988;

/**
 * Build year's range options list for filter
 * Order is from highest year to lowest
 *
 * @param {string} firstLabel Label for the first year
 * @param {bool} periods Use season's periods
 * @param {number} current First year in the list
 * @param {number} last Last year in the list
 *
 * @returns {Array} List of years options
 */
const yearsRange = (firstLabel, periods, current = currentYear, last = lastYear) => {
    const years = [];
    const currYear = current + (periods ? 1 : 0);
    for (let i = currYear; i >= last; i--) {
        const year = periods ? `${i - 1}-${i}` : i;
        const label = periods ? `${i - 1}-${i.toString().slice(-2)}` : i;
        years.push({
            value: year,
            displayName: (currYear === i ? firstLabel : label).toString()
        });
    }

    return years;
};

export { currentYear, currentPeriod, yearsRange };



// WEBPACK FOOTER //
// ./src/js/helpers/yearsRange.js